import { Box, Text, Tooltip, UxInfoSign } from '@bymason-private/legacy-pattern-components';

export default function TotalUsageHeader() {
  return (
    <div>
      <Tooltip
        arrow
        placement='right'
        title={
          <span>
            Connectivity usage data is updated
            <br />
            on a daily basis.
          </span>
        }
      >
        <Box
          sx={{
            alignItems: 'baseline',
            display: 'flex',
            gap: 0.5,
          }}
        >
          <Text variant='h5'>Total usage</Text>
          <div>
            <UxInfoSign
              sx={{
                fontSize: 15,
                opacity: 0.3,
              }}
            />
          </div>
        </Box>
      </Tooltip>
    </div>
  );
}
